module.exports = __webpack_public_path__ + "img/couples-005.ddb24692.jpg";